import { render } from "./GraphKeyword.vue?vue&type=template&id=0f5620a4&scoped=true"
import script from "./GraphKeyword.vue?vue&type=script&lang=js"
export * from "./GraphKeyword.vue?vue&type=script&lang=js"

import "./GraphKeyword.vue?vue&type=style&index=0&id=0f5620a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5620a4"]])

export default __exports__